import DisqualifyModal from './DisqualifyModal';

export default DisqualifyModal;
